import authorizedBrands1 from '../images/authorizeBrands/1.jpeg'
import authorizedBrands2 from '../images/authorizeBrands/2.jpeg'
import authorizedBrands3 from '../images/authorizeBrands/3.jpeg'
import authorizedBrands4 from '../images/authorizeBrands/4.jpeg'
import authorizedBrands5 from '../images/authorizeBrands/5.jpeg'
import authorizedBrands6 from '../images/authorizeBrands/6.jpeg'
import authorizedBrands7 from '../images/authorizeBrands/7.jpeg'
import authorizedBrands8 from '../images/authorizeBrands/8.jpeg'
const authorizedBrandsData = [{
    image: authorizedBrands1
},
{
    image: authorizedBrands2
},
{
    image: authorizedBrands3
},
{
    image: authorizedBrands4
},
{
    image: authorizedBrands5
},
{
    image: authorizedBrands6
},
{
    image: authorizedBrands7
},
{
    image: authorizedBrands8
}]
export default authorizedBrandsData